// import { observable } from 'mobx'

function normalizeFaculties (faculties) {
  return faculties.map(({ id, name, title, department, netid, lincus_author_id }) =>
    ({ id, name, title, department, netid, lincusAuthorId: lincus_author_id }))
}

export default class ProjectModel {
  id
  name
  descShort
  descLong
  descMeta
  sortDate
  createdAt
  updatedAt
  image
  type
  contactName
  subtype
  faculties
  highlight

  constructor (obj) {
    // Assume creation from JSON AJAX call
    const normalizedObj = ProjectModel.normalizeFromJS(obj)

    this.id = normalizedObj.id
    this.name = normalizedObj.name
    this.descShort = normalizedObj.descShort
    this.descLong = normalizedObj.descLong
    this.descMeta = normalizedObj.descMeta
    this.sortDate = normalizedObj.sortDate
    this.createdAt = normalizedObj.createdAt
    this.updatedAt = normalizedObj.updatedAt
    this.image = normalizedObj.image
    this.type = normalizedObj.type
    this.contactName = normalizedObj.contactName
    this.subtype = normalizedObj.subtype
    this.faculties = normalizedObj.faculties
    this.highlight = normalizedObj.highlight
  }

  get content () {
    return this.descShort
  }

  static normalizeFromJS (obj) {
    const image = {
      main: obj.image,
      tile: obj.tile_image,
      details: obj.details_image,
      width: obj.image_width,
      height: obj.image_height
    }

    const faculties = normalizeFaculties(obj.faculties || [])

    return {
      id: obj.id,
      name: obj.name,
      descShort: obj.desc_short,
      descLong: obj.desc_long,
      descMeta: obj.desc_meta,
      sortDate: obj.sort_date,
      createdAt: obj.created_at,
      updatedAt: obj.updated_at,
      image,
      type: obj.projecttype,
      contactName: obj.contact_name,
      subtype: obj.project_subtype,
      faculties,
      highlight: obj.highlight
    }
  }

  static fromJS (obj) {
    return new ProjectModel(obj)
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/models/ProjectModel.js